// removed by extract-text-webpack-plugin
module.exports = {"textContainer":"src-components-SecurityTrade-DisclaimerViews-___index__textContainer___26da_","numbered":"src-components-SecurityTrade-DisclaimerViews-___index__numbered___1LPp2","lettered":"src-components-SecurityTrade-DisclaimerViews-___index__lettered___3bqSO","roman":"src-components-SecurityTrade-DisclaimerViews-___index__roman___33TnM","bulleted":"src-components-SecurityTrade-DisclaimerViews-___index__bulleted___3P8XB","link":"src-components-SecurityTrade-DisclaimerViews-___index__link___RGOpd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SecurityTrade/DisclaimerViews/index.css
// module id = 189
// module chunks = 3